(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6703],{

/***/ 97481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/mercari-local/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-04-14",
      tag: "Mercari",
      title: "What You Need To Know To Sell and Earn More With Mercari Local",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["As a seller, it may be a recurring inconvenience for you to go through the hassle of meetups for your sales. One great way to do away with this is with Mercari Local. It is convenient to shop and sell locally without dealing with meetups. You can simply shop and sell locally without meeting up with strangers or worrying about packing and shipping.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What is Mercari Local?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "With Mercari Local, merchants are paid considerably faster than they would be if they used conventional delivery. It's simple to sell with Mercari Local. All you have to do is select Mercari Local as an additional delivery method after listing an item in the Mercari app. One of their partners, Uber or FedEx SameDay\xAE City, will be in charge of delivery. The item will be picked up from the seller and delivered to the buyer without the need for contact."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Where is Mercari Local available?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Mercari Local is presently accessible in 16 markets via FedEx SameDay\xAE City. With locations such as Houston, Washington, D.C./Baltimore, Chicago, Philadelphia, Dallas/Fort Worth, Charlotte, Detroit, Denver, Minneapolis/St. Paul, Sacramento, St. Louis, Cleveland, Portland, Phoenix, Memphis, and the San Francisco Bay Area."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How does Mercari Local work for sellers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Mercari Local works for sellers by simply listing your item on the platform and choosing Mercari Local as your pickup and delivery option. After that, you can schedule your pickup, and Mercari Local will automatically match your schedule with the buyers. You'll get notifications along the way, and then you can place your item for pick up and get paid after the buyer rates the transaction."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What Items are ideal for Mercari Local"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "An important thing for sellers to take note of when using Mercari Local is that the items advertised must be under 50 pounds and can fit into a car's trunk (45\" x 35\" x 15\")."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If you're selling in the New York City area, you will be required to state if your item is small, medium, or large. Uber will utilize a walker, a biker, or a scooter for small and medium things, and a driver will pick up your item if they are bigger items.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Mercari Local is ideal for selling the following items:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Table lamps "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "House plants"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Weights and training bands"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Baby-related items like carriers, strollers, high chairs, and baby gates"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Jigsaw puzzles, video game consoles, children's bikes, and tiny BBQs "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Mixers, bread makers, and baking utensils."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Monitors, standing desks, and chairs "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What can't be delivered with Mercari Local"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Now, as for what can't be sold on Mercari Local due to delivery constraints are the following items:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Couches, bed frames, mattresses, and an example of large furniture."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Refrigerators and other large appliances"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Outdoor gear that wouldn't fit safely in the trunk of a car"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to pack the items"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Now that you've sold your item, the next step is to pack it securely for shipping. Once you prepare the item, make sure that you properly wrap your item to protect it from damage during shipment if necessary. Always take precautions to box it carefully if the item is fragile. It is also a good practice to never overlook the finer points."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If possible, always make a note of the buyer's apartment number on your package (if applicable). While your item is in transportation, keep in mind that there may be bumps or sudden halt. In the app, you can also make pickup notes. If your item, such as computer parts or an instrument, is bulky or huge, fold it down to its smallest size before wrapping and labeling it.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Mercari Local Delivery partners"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Based on the price, the time of day, and the distance between the buyer and the seller, Mercari Local will find the best delivery provider for you. Their delivery partners are Uber and FedEx SameDay\xAE City to safely deliver your things locally."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to add Mercari Local to existing listings?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Mercari Local's rapid opt-in tool allows you to update many listings. So if you want to add it to your existing listing, you can find the notification on your listings page."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When Mercari Local is the same price or less expensive than standard shipping, you will be notified. It's ideal for those large products that cost a lot of money to send. Additionally, because Mercair Local tells customers about local offers, more eyes will be drawn to your offerings."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Tips on ensuring safe delivery of items"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["It is recommended that sellers take extra precautions to ensure that their items will be safely delivered to buyers. To direct the driver to your pickup location, always leave explicit pickup directions in the Mercari app.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "There's no need to meet the driver in person if you do it this way. You may, for example, text the driver instructions such as \"Please don't ring the doorbell.\" or \"I'll place the item next to the entry mat on my front porch.\""
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "And if your item is hefty and weighs more than 10 pounds, wrap it in something sturdy that you can carry from the car to the front door. If many products are being delivered, place them in a bag or a box together."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Other Tips to Boost Your Sales"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Mercari Local is a convenient way to sell your items, but using an innovative automation tool will help make your daily operations more streamlined and efficient, further your sales, and optimize your operations."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop is an intelligent app that functions as your virtual sales expert that allows you to list and cross-list items on various online marketplaces easily. Additional features that can help you optimize your operations include relisting and cross-listing on Mercari, and automating Poshmark activities such as follows, likes, send offers, and more."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop is specially designed to let you spend more time on other critical aspects of your business rather than manually listing on various marketplaces."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Try it for yourself! ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "Register for free"
        }), " and enjoy a 7-day trial!", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/mercari-local.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "What You Need To Know To Sell and Earn More With Mercari Local"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Learn how to boost your sales locally and earn faster by using Mercari Local to get your items delivered on the same day and get people to notice your business."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/mercari-local"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/mercari-local"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "What You Need To Know To Sell and Earn More With Mercari Local"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Learn how to boost your sales locally and earn faster by using Mercari Local to get your items delivered on the same day and get people to notice your business."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=4"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "April 14th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "April 14th, 2022"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 76233:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mercari-local",
      function () {
        return __webpack_require__(97481);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(76233); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);